export default {
  SET_employees(state, payload) {
    state.employees = payload
  },
  SET_birthdays(state, payload) {
    state.birthdays = payload
  },
  SET_contactMessagesWebSite(state, payload) {
    state.contactMessagesWebSite = payload
  },
  SET_paychecks(state, payload) {
    state.paychecks = payload
  },
  SET_employee_scales(state, payload) {
    state.employee_scales = payload
  },
  SET_employee_swaps(state, payload) {
    state.employee_swaps = payload
  },
  SET_income_taxes(state, paylaod) {
    state.income_taxes = paylaod
  },
}
